.message {
  display: flex;
  flex-direction: column;
  inline-size: 100%;
  min-inline-size: 0;
}
/* Auto margins collapse when space runs out, keeping the heading reachable.
   The caller owns the content pane's height, padding and scrolling. */
.page {
  max-inline-size: 30rem;
  margin: auto;
  gap: var(--space__3xl);
  text-align: center;
}
.section {
  max-inline-size: 40rem;
  gap: var(--space__xl);
  text-align: start;
}
/* A well fills its row; the copy inside keeps the section's reading width. No border: the fill
   alone marks the region. */
.well {
  max-inline-size: none;
  padding: var(--space__xl);
  border-radius: var(--border-radius__lg);
  background-color: var(--color__gray-50);
}
.well .copy {
  max-inline-size: 40rem;
}
.copy {
  display: flex;
  flex-direction: column;
  gap: var(--space__2xl);
}
.section .copy {
  gap: var(--space__md);
}
.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space__md);
}
.page .actions {
  justify-content: center;
}
